<template>
	<div class="vital analysis">
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="record card">
					<h5>Records</h5>
					<VitalTable
						:vital="vital"
						:event="event">
					</VitalTable>
				</div>
			</el-col>
			<el-col :span="16">
				<div class="card">
					<h5>Graph</h5>
					<VitalGraph
						:vital="vital"
						:data="event">
					</VitalGraph>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import VitalAnalysis from './mixin'
import VitalTable from './Table'
import VitalGraph from '../../../graph/type/Vital'

export default {
	name: 'vital-analysis',
	mixins: [ VitalAnalysis ],

	props: {
		vital: {
			type: String,
			required: true
		},
		event: {
			type: Array,
			required: true
		}
	},

	components: {
		VitalGraph,
		VitalTable
	}
}
</script>
<style lang="scss" scoped>
@import "../../component/table/style/analysis.scss";
.record.card {
	max-height: 325px;
}
</style>
